export const rtlProps = { dir: 'rtl', lang: 'fa' };

export const TEXT = {
    labels: {id: 'ID'},
    addSection: 'افزودن سرفصل',
    sectionSettings: 'مشخصات سرفصل',
    contentsHeader: 'محتوای سرفصل',
    addContent: 'اضافه کردن محتوا',
    noContents: 'هنوز هیچ محتوایی برای این سرفصل تعریف نشده است.',
    buttons: {
        cancel: 'لغو',
        save: 'ذخیره',
        saveNew: 'افزودن سرفصل',
    },
    switch: {
        active: 'فعال',
        inactive: 'غیرفعال'
    }
};

export const defaultNewSection = (courseId) => ({
    id: '',
    position: 0,
    description: '',
    version: 1,
    is_active: true,
    course_id: courseId,
    contents: []
});

export const CONTENT_TYPE = {
    LESSON: 0,
    PROJECT: 1,
};

export const PROJECT_VALIDATION_TYPES = [
    "exact",
    "contains",
    "regex",
    "stdout",
];

export const PROJECT_RULE_TYPES = [
    "missing_contains",
    "missing_regex",
    "contains_forbidden",
    "stdout_missing",
];

export const PROJECT_LANGUAGES = [
    "python",
    "javascript",
    "typescript",
    "java",
    "cpp",
    "c",
    "go",
    "rust",
];